import React from 'react'
import TitledPage from "../layout/TitledPage";
import { Paragraph } from '../style';
import SoftwareInfo from "touhou-fm/SoftwareInfo";
import { Heading } from '@chakra-ui/react';

export default () => <TitledPage title="Geeks">
    <Paragraph>Welcome to the geeks page of TouHou.FM. This page contains all the geeky details of the site and its software</Paragraph>
    <Heading as="h2" size="xl">Software information</Heading>
    <Paragraph>These are the currently running versions of the radio software.</Paragraph>
    <SoftwareInfo />
</TitledPage>